import axios from 'axios';
import { URL_AGENCY_LIST } from './config';

export async function getAgencyList() {
    const result = await axios.get(URL_AGENCY_LIST);
    console.log("🚀 ~ file: agencyListCrud.js ~ line 6 ~ getAgencyList ~ result", result)
    return result.data.data;
};